import { render, staticRenderFns } from "./OnboardingScreenFullWidth.vue?vue&type=template&id=c7f5c438&scoped=true&"
import script from "./OnboardingScreenFullWidth.vue?vue&type=script&lang=js&"
export * from "./OnboardingScreenFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingScreenFullWidth.vue?vue&type=style&index=0&id=c7f5c438&prod&lang=scss&"
import style1 from "./OnboardingScreenFullWidth.vue?vue&type=style&index=1&id=c7f5c438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f5c438",
  null
  
)

export default component.exports